import { Component, OnInit } from '@angular/core';
import { ClienteLogin, ClienteVAM, UsuarioVamTit, Menu } from '../../../views/login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { PolizaEntity } from '../../empresas/entities/polizas_cliente_entity';
import { VamTitularesPolizasService } from '../../vam/polizas/vam-titulares-polizas.service';
import { RenunciaBeneficioSeguroService } from './renuncia-beneficio-seguro.service';
import { VamBancosEntity, DevolucionSeguroTitularVam } from '../../vam/vam_entity';
import { UtilService } from '../../../components/common/utils/util.service';
import { VamTitularesService } from '../../vam/titulares/vam-titulares.service';
import { VamTitularEntity } from '../../vam/titulares/entities/vam_titulares_entity';
import { Router } from '@angular/router';
import { ConsultarUsuarioVAM } from '../../../components/common/utils/consultarUsuarioVAM';
import { Observable } from 'rxjs';

const swal = require("sweetalert2");


declare var jQuery: any;

@Component({
    selector: 'renunciaBeneficios',
    templateUrl: 'renuncia-beneficio-seguro.template.html'
})

export class RenunciaBeneficioSeguroComponent implements OnInit {
    usuario: ClienteLogin;
    clienteVam: ClienteVAM;
    usuarioVam: UsuarioVamTit;
    polizas: PolizaEntity[];
    public showLoader: string = "";
    bancos: VamBancosEntity[] = new Array<VamBancosEntity>();
    renunciaBeneficioEntity: DevolucionSeguroTitularVam = new DevolucionSeguroTitularVam();
    vamTitular: VamTitularEntity = new VamTitularEntity();
    banderaPolizas: number = 0;
    edicionRepLegal: boolean;


    constructor(
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService,
        private vamTitularesPolizasService: VamTitularesPolizasService,
        private renunciaBeneficioService: RenunciaBeneficioSeguroService,
        public utilService: UtilService,
        private vamTitularService: VamTitularesService,
        private router: Router,
        private consultarVAM: ConsultarUsuarioVAM
    ) {
        this.renunciaBeneficioEntity = new DevolucionSeguroTitularVam();
        this.renunciaBeneficioEntity.CodigoBanco = 0;
        this.renunciaBeneficioEntity.TipoCuenta = 0;
    }

    ngOnInit(): void {
        this.showLoader = "sk-loading";
        this.renunciaBeneficioEntity = new DevolucionSeguroTitularVam();
        this.renunciaBeneficioEntity.CodigoBanco = 0;
        this.renunciaBeneficioEntity.TipoCuenta = 0;
        this.edicionRepLegal=true;
        try {
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
            this.consultarVAM.iniciarUsuarioVAM();
            if (this.usuario == null) {
                let error = { "status": 998, "message": "Acceso denegado" };
                this.handleError.redirectUrl(error)
            } else {
                let bandera = this.sessionTokenService.useJwtHelper();

                if(this.ConsultarMenu(this.usuario.Menu)){
                    if (!bandera) {
                        this.clienteVam = jQuery.parseJSON(this.sesionStorageService.retrieve("uservam"));
                        this.renunciaBeneficioService.ConsultarBancos().subscribe(
                            result => {
                                this.bancos = result.filter(x => x.CodigoBanco != 1);
                                this.vamTitularService.ConsultarDatosVamTitular().subscribe(
                                    resultVam => {
                                        this.vamTitular = resultVam;
                                        this.CargarTodo();
                                    },
                                    error => {
                                        this.handleError.redirectUrl(error)
                                    }
                                );
                            },
                            error => {
                                this.handleError.redirectUrl(error);
                            }
                        );
                    }
                }else{
                    this.router.navigate(["/mainView"]);
                }
            }
        } catch (ex) {

        }
    }

    CargarTodo() {
        this.banderaPolizas = 0;
        this.usuarioVam = new UsuarioVamTit();        
        this.usuarioVam.CodigoCiudad = this.clienteVam.CodigoCiudad;
        this.usuarioVam.CodigoCliente = this.clienteVam.CodigoCliente;
        this.usuarioVam.CodigoUnidad = this.clienteVam.CodigoUnidad;
        this.usuarioVam.Cedula = this.usuario.Cedula;
        
        if(this.vamTitular.NombreRepresentante==null)
        {
            this.renunciaBeneficioEntity.NombreTitularCuenta="";
           }
           else
           {
            this.renunciaBeneficioEntity.NombreTitularCuenta=this.vamTitular.NombreRepresentante;
           }
            
            if(this.vamTitular.CedulaRepresentante==null){
                this.renunciaBeneficioEntity.CedulaTitularCuenta="";
            }
            else{
                this.renunciaBeneficioEntity.CedulaTitularCuenta=this.vamTitular.CedulaRepresentante;
            }
            
          
            if(this.renunciaBeneficioEntity.CedulaTitularCuenta!="" && this.renunciaBeneficioEntity.NombreTitularCuenta!="")
            {
                this.edicionRepLegal=true; 
               
            }
            else{

                this.edicionRepLegal=false; 
            }
          
        this.vamTitularesPolizasService.ConsultarPolizasVamTitular(this.usuarioVam).subscribe(
            result => {
                result.forEach(a => {
                    if (a.EsObligatoria == true) {
                        if (a.Devolucion == false) {
                            this.banderaPolizas = 1;
                        }
                    }
                });
                if (this.banderaPolizas == 0) {
                    this.banderaPolizas = 2;
                }
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }

    ConsultarMenu(hijos: Menu[]): boolean{
        let bandera = false;
        hijos.forEach(a=>{
            if(a.Hijos != null && a.Hijos.length > 0){
                let resultado = this.ConsultarMenu(a.Hijos);
                if(resultado == true){
                    bandera = true;
                }
            }else{
                if(a.Ruta == "/VAM/renunciaBeneficioMedico"){
                    bandera = true;
                }
            }
        });
        return bandera;
    }

    enviarRenuncia() {
        swal({
            title: 'Solicitud de renuncia de beneficio médico',
            text: ' La información del representante legal se validará con la proporcionada por la Universidad          ¿Esta seguro que la información proporcionada es correcta? ',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, estoy de acuerdo!',
            cancelButtonText: 'No'
          }).then((function(result) {
            this.cancelarBeneficio();
          }).bind(this), function(dismiss) {
            swal({
                title: 'Solicitud de renuncia de beneficio médico',
                text: 'Solicitud cancelada.',
                type: 'success'
            });
          });
    }
    cancelarBeneficio(){
        this.renunciaBeneficioEntity.CodigoTitular = this.vamTitular.CodigoTitular;
        this.renunciaBeneficioEntity.CodigoCliente = this.clienteVam.CodigoCliente;
        this.renunciaBeneficioEntity.CodigoCiudad = this.clienteVam.CodigoCiudad;
        this.renunciaBeneficioEntity.CedulaTitular=this.vamTitular.Cedula;
        //datos represntante legal
        this.renunciaBeneficioEntity.NombreRepresentante=this.vamTitular.NombreRepresentante;
        this.renunciaBeneficioEntity.CedulaRepresentante=this.vamTitular.CedulaRepresentante;
        this.renunciaBeneficioEntity.CelularRepresentante=this.vamTitular.CelularRepresentante;
        this.renunciaBeneficioEntity.MailRepresentante=this.vamTitular.MailRepresentante;
        this.renunciaBeneficioEntity.NombreCompletoTitular=this.vamTitular.ApellidoPaterno+" "+this.vamTitular.ApellidoMaterno+" "+this.vamTitular.PrimerNombre+" "+this.vamTitular.SegundoNombre;
        this.showLoader = "sk-loading";
        if (this.vamTitular.Cedula == this.renunciaBeneficioEntity.CedulaTitularCuenta) {
            this.renunciaBeneficioEntity.Actualizar = true;
        } else {
            this.renunciaBeneficioEntity.Actualizar = false;
        }
        this.renunciaBeneficioService.SolicitarRenunciaBeneficio(this.renunciaBeneficioEntity).subscribe(
            result => {
                this.showLoader = "";
                if (result == false) {
                    swal({
                        title: 'Solicitud de renuncia de beneficio médico',
                        text: 'Ha ocurrido un error al momento de enviar su solicitud.',
                        type: 'error'
                    });
                } else {
                    swal({
                        title: 'Solicitud de renuncia de beneficio médico',
                        text: 'Para concluir el proceso, ingresa a tu correo electrónico y sigue las instrucciones',
                        type: 'success'
                    }).then((function () {
                        window.location.reload(true);
                    }).bind(this));
                }
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/paginas_por_cliente/catolica_quito/renuncia-beneficio-seguro.component.ts